import React from "react";
import {XMarkIcon} from "@heroicons/react/24/solid";

export function UserAccountMediaRemoveButton({onClick, ariaLabel = "삭제"}) {
    return (
        <button
            type="button"
            className="user-account-edit-form__file-picker-remove"
            onClick={onClick}
            aria-label={ariaLabel}
        >
            <XMarkIcon className="user-account-edit-form__file-picker-remove-icon" />
        </button>
    );
}

function UserAccountProfileImageField({
    fileInputRef,
    fileName,
    showRemove = false,
    previewSrc,
    onFileChange,
    onRemove,
}) {
    return (
        <div className="user-account-edit-form__media">
            <div className="user-account-edit-form__file-picker">
                <input
                    type="file"
                    accept="image/*"
                    className="user-account-edit-form__file-input-hidden"
                    ref={fileInputRef}
                    onChange={onFileChange}
                />
                <button
                    type="button"
                    className="user-account-edit-form__file-picker-btn"
                    onClick={() => fileInputRef.current?.click()}
                >
                    파일 선택
                </button>
                <span
                    className="user-account-edit-form__file-picker-name"
                    title={fileName || undefined}
                >
                    {fileName || "선택된 파일 없음"}
                </span>
                {showRemove && <UserAccountMediaRemoveButton onClick={onRemove} />}
            </div>
            {previewSrc && (
                <img
                    src={previewSrc}
                    alt="프로필 미리보기"
                    className="user-account-edit-form__avatar"
                />
            )}
        </div>
    );
}

export default UserAccountProfileImageField;
